export default __webpack_public_path__ + "static/media/output.96d995c9.webm";